// extracted by mini-css-extract-plugin
export default {"main":"FactoryRegistraction_main__-7Oh9","content":"FactoryRegistraction_content__3pjOa"};